

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' 

import router from './router'
import './styles/element-ui.css'
import './styles/index.css'
import store from './store'
import JsEncrypt from 'jsencrypt'
Vue.prototype.$jsEncrypt = JsEncrypt














Vue.use(VueRouter)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(WechatPlugin)

Vue.use(ElementUI, { locale })
Vue.prototype.$devicePixelRatio = 2

Vue.config.productionTip = false
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')















// WEBPACK FOOTER //
// ./src/main.js